import isEmpty from 'lodash/isEmpty';
import reduce from 'lodash/reduce';
import replace from 'lodash/replace';
import isArray from 'lodash/isArray';

// eslint-disable-next-line import/no-cycle
import fetchClient from './fetchClient';
import fetchServer from './fetchServer';
import logger from './logger';

/**
 * Convert an object into a query string.
 *
 * @param {Object} params  parameters to be converted to query string
 */
export const toQueryString = params => reduce(params, (result, value, key) => {
  if (value === undefined || key === undefined) {
    return result;
  }
  if (isArray(value) && value.length > 0) {
    const resultString = reduce(value, (result, valueItem) => `${result}${result === '' ? '' : '&'}${key}=${valueItem}`, '');
    return `${result}${result === '' ? '?' : '&'}${resultString}`;
  }
  /* eslint-disable-next-line no-param-reassign */
  value = replace(value, new RegExp('#', 'g'), '%23');
  return `${result}${result === '' ? '?' : '&'}${key}=${value}`;
}, '');

/**
 * Function to add a query parameter to a legal url.  This does not support url's with a #hash.
 *
 * @param {*} uri The full url to update
 * @param {*} key the key part of the key/value query parameter
 * @param {*} value the value part of the key/value query parameter
 */
export const updateQueryStringParameter = (uri, key, value) => {
  const re = new RegExp(`([?&])${key}=.*?(&|$)`, 'i');
  const separator = uri.indexOf('?') !== -1 ? '&' : '?';
  if (uri.match(re)) {
    return uri.replace(re, `$1${key}=${value}$2`);
  }

  return `${uri}${separator}${key}=${value}`;
};

/**
 * Make a request with the ability to refresh tokens in the event of a 401.
 * This will work on both the client and server.
 * Server side calls require that the next context is passed in.
 *
 * @param {String} url                      The url of the request.
 * @param {Object} options
 * @param {String} options.method           The method for the request.
 * @param {Object} options.headers          The headers to send with the request.
 * @param {Object} options.body             The body to send with the request.
 * @param {Object} options.ctx              The context of the next request.
 */
const customFetch = async (url, options) => {
  if (process.browser) {
    return fetchClient(url, options);
  }

  if (!isEmpty(options.ctx)) {
    return fetchServer(url, options);
  }

  logger.logError('No next ctx passed to server side fetch', {
    url,
    body: options.body,
    headers: options.headers,
    method: options.method,
  });

  return () => {};
};

export default customFetch;
